import ImpersonaHome from "@/modules/Impersona/Pages/ImpersonaHome.vue";
export default [
  {
    path: "impersona/",
    name: "IMPERSONA_HOME",
    component: ImpersonaHome,
    props: true,
    meta: {
      authenticationRequired: true,
    },
  },
];
